// Legal documents (Turkish). Premium, solid drafts — review by a lawyer recommended.
// Content is intentionally static; a {contact} placeholder is filled from site settings at render time.

export const LEGAL_DOCS = {
  "gizlilik-politikasi": {
    overline: "Yasal",
    title: "Gizlilik Politikası",
    updated: "Son güncelleme: 2026",
    sections: [
      {
        h: "Giriş",
        body: [
          "Meguiar's İzmit (\"biz\") olarak kişisel verilerinizin gizliliğine önem veriyoruz. Bu Gizlilik Politikası, web sitemizi kullandığınızda hangi verileri topladığımızı, bu verileri nasıl kullandığımızı ve haklarınızın neler olduğunu açıklar.",
        ],
      },
      {
        h: "Hangi verileri topluyoruz?",
        body: [
          "Randevu ve iletişim formları aracılığıyla bize ilettiğiniz ad-soyad, telefon numarası, araç marka/model bilgisi, seçtiğiniz hizmet ve eklediğiniz notları topluyoruz.",
          "Bu bilgiler yalnızca sizin tarafınızdan, talebinizi iletmek amacıyla isteğe bağlı olarak paylaşılır.",
        ],
      },
      {
        h: "Verileri ne amaçla kullanıyoruz?",
        body: [
          "Topladığımız verileri; randevu taleplerinizi karşılamak, sizinle iletişime geçmek, hizmetlerimiz hakkında bilgi vermek ve hizmet kalitemizi artırmak amacıyla kullanırız.",
          "Verileriniz, izniniz olmadan pazarlama amacıyla üçüncü taraflarla paylaşılmaz veya satılmaz.",
        ],
      },
      {
        h: "Veri paylaşımı",
        body: [
          "Kişisel verileriniz, yasal yükümlülükler dışında üçüncü kişilerle paylaşılmaz. İletişim taleplerinizi WhatsApp veya telefon üzerinden ilettiğinizde, ilgili platformların kendi gizlilik koşulları geçerlidir.",
        ],
      },
      {
        h: "Veri saklama süresi",
        body: [
          "Verileriniz, işlendikleri amaç için gerekli olan süre boyunca ve ilgili mevzuatın öngördüğü zamanaşımı süreleri kadar saklanır. Bu sürelerin sonunda verileriniz silinir, yok edilir veya anonim hâle getirilir.",
        ],
      },
      {
        h: "Haklarınız",
        body: [
          "6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında verilerinize erişme, düzeltme, silme ve işlemeye itiraz etme haklarına sahipsiniz. Detaylar için KVKK Aydınlatma Metni'ni inceleyebilirsiniz.",
        ],
      },
      {
        h: "İletişim",
        body: ["Gizlilikle ilgili her türlü soru ve talebiniz için bize ulaşabilirsiniz: {contact}"],
      },
    ],
  },

  "kvkk-aydinlatma-metni": {
    overline: "Yasal",
    title: "KVKK Aydınlatma Metni",
    updated: "Son güncelleme: 2026",
    sections: [
      {
        h: "Veri Sorumlusu",
        body: [
          "6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") uyarınca, kişisel verileriniz veri sorumlusu sıfatıyla Meguiar's İzmit tarafından aşağıda açıklanan kapsamda işlenmektedir.",
        ],
      },
      {
        h: "İşlenen Kişisel Veriler",
        body: [
          "Kimlik (ad-soyad), iletişim (telefon), araç bilgisi (marka/model) ve talep içeriği (seçilen hizmet, notlar) gibi tarafınızca paylaşılan veriler işlenmektedir.",
        ],
      },
      {
        h: "İşleme Amaçları",
        body: [
          "Verileriniz; randevu ve hizmet taleplerinin yönetimi, müşteri ilişkilerinin yürütülmesi, iletişim faaliyetleri ve hizmet kalitesinin geliştirilmesi amaçlarıyla işlenir.",
        ],
      },
      {
        h: "Hukuki Sebep",
        body: [
          "Kişisel verileriniz; KVKK m.5 kapsamında açık rızanıza, bir sözleşmenin kurulması/ifası ve veri sorumlusunun meşru menfaati hukuki sebeplerine dayanılarak işlenir.",
        ],
      },
      {
        h: "Aktarım",
        body: [
          "Verileriniz, yalnızca yasal yükümlülükler veya hizmetin gerektirdiği hâllerde ve mevzuata uygun olarak aktarılabilir. Yurt dışına veri aktarımı, açık rızanız olmadan yapılmaz.",
        ],
      },
      {
        h: "Toplama Yöntemi",
        body: [
          "Verileriniz; web sitemizdeki randevu/iletişim formları, telefon ve WhatsApp gibi kanallar aracılığıyla elektronik ortamda toplanır.",
        ],
      },
      {
        h: "KVKK m.11 Kapsamındaki Haklarınız",
        body: [
          "Kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, işlenme amacını öğrenme, eksik/yanlış işlenmişse düzeltilmesini, ilgili mevzuata uygun olarak silinmesini/yok edilmesini isteme ve işlemeye itiraz etme haklarına sahipsiniz.",
        ],
      },
      {
        h: "Başvuru",
        body: ["Haklarınızı kullanmak için bizimle iletişime geçebilirsiniz: {contact}"],
      },
    ],
  },

  "cerez-politikasi": {
    overline: "Yasal",
    title: "Çerez Politikası",
    updated: "Son güncelleme: 2026",
    sections: [
      {
        h: "Çerez Nedir?",
        body: [
          "Çerezler, web sitelerini ziyaret ettiğinizde tarayıcınıza kaydedilen küçük metin dosyalarıdır. Sitenin düzgün çalışmasını sağlamak ve deneyiminizi iyileştirmek için kullanılırlar.",
        ],
      },
      {
        h: "Kullandığımız Çerezler",
        body: [
          "Zorunlu çerezler: Sitenin temel işlevleri ve tercihlerinizin (ör. çerez onayınız) hatırlanması için gereklidir.",
          "Analitik çerezler: Yalnızca açık onayınız ile etkinleşir. Onay verdiğinizde, ziyaret istatistiklerini anonim olarak ölçmek için (ör. Google Analytics) kullanılabilir. Onay vermezseniz analitik çerezler çalıştırılmaz.",
        ],
      },
      {
        h: "Üçüncü Taraf İzleme",
        body: [
          "Sitemiz, varsayılan olarak üçüncü taraf pazarlama veya oturum kaydı izleme araçları çalıştırmaz. Analitik araçlar yalnızca siz onay verdiğinizde devreye girer.",
        ],
      },
      {
        h: "Çerezleri Yönetme",
        body: [
          "Tarayıcı ayarlarınızdan çerezleri silebilir veya engelleyebilirsiniz. Ayrıca sitedeki çerez bandı üzerinden tercihinizi belirleyebilirsiniz. Çerezleri reddetmeniz hâlinde sitenin temel işlevleri çalışmaya devam eder.",
        ],
      },
      {
        h: "İletişim",
        body: ["Çerez politikamızla ilgili sorularınız için bize ulaşın: {contact}"],
      },
    ],
  },
};
